import * as React from 'react';

const SvgComponent = _props => {
  const {'aria-label': ariaLabel, role, alt, ...rest} = _props;
  const props = {
    ...rest,
    ...(ariaLabel || alt
      ? {
          role: role || 'img',
          'aria-label': ariaLabel,
          alt
        }
      : {
          'aria-hidden': 'true'
        })
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 139 175" {...props}>
      <path
        fill="#FCB23A"
        d="M133.4 17.7C128.2 10.9 120.2 7 111.6 7H27.4c-8.6 0-16.6 3.9-21.8 10.7C.4 24.6-1.3 33.2 1 41.5 3.1 49 8.3 55.4 15.3 58.8l22.1 10.9c3.2 1.6 4.5 5.4 2.9 8.5-.8 1.5-2.1 2.7-3.7 3.2-1.6.6-3.4.4-4.9-.3-1.7-.8-3.8-.1-4.7 1.7-.9 1.8-.1 3.9 1.6 4.7 1.9.9 3.9 1.4 6 1.4 1.5 0 3-.2 4.4-.7 3.4-1.2 6.2-3.6 7.8-6.8 3.3-6.7.5-14.7-6.2-18l-22.1-11c-5.2-2.5-9-7.2-10.6-12.8-1.7-6.1-.5-12.5 3.4-17.6 3.9-5 9.7-7.9 16.1-7.9h84.1c6.4 0 12.2 2.9 16.1 7.9 3.9 5.1 5.1 11.5 3.4 17.6-1.6 5.6-5.4 10.3-10.6 12.8l-22 10.9c-6.7 3.3-9.4 11.4-6.2 18 1.6 3.2 4.4 5.7 7.8 6.8 1.4.5 2.9.7 4.4.7 2 0 4.1-.5 6-1.4 1.8-.9 2.5-3 1.6-4.7s-3-2.5-4.8-1.6c-1.5.8-3.3.9-4.9.3-1.6-.6-2.9-1.7-3.7-3.2-1.6-3.1-.2-7 2.9-8.5l22.1-10.9c7-3.4 12.2-9.7 14.3-17.3 2.4-8.3.7-16.9-4.5-23.8"
      />
      <path
        fill="#FFD54B"
        d="M77 104.8H61.8c-2.6 2.8-2.9 11.4 4 14V129c-3.4 1.3-5.6 4.5-5.8 7.9-4.1.9-7.3 2.7-9.3 5.2v5.4H88v-5.4c-2-2.5-5.1-4.3-9.3-5.2-.2-3.4-2.4-6.6-5.8-7.9v-10.2c7-2.6 6.6-11.1 4.1-14M61.8 104.8H77c7.1-4 12.6-9.8 17-16.6 3.6-5.7 6.5-12.2 8.7-19 4.6-14.5 6.5-30.8 7.2-45.6.2-4.6.3-9.1.4-13.3.1-3.6.1-7 .1-10.1h-82c0 3.2 0 6.5.1 10.1.1 4.2.2 8.7.4 13.3.7 14.8 2.6 31.1 7.2 45.6 2.2 6.9 5 13.3 8.7 19 4.3 6.9 9.9 12.6 17 16.6"
      />
      <path
        fill="#FCB23A"
        d="M69.3 26.8c.4-1 .9-1 1.2 0L73 36l9 .3c1.1 0 1.3.6.4 1.2l-5.9 4.2c-.9.6-1.4 2-1.1 3.1l2 7.3c.3 1.1-.2 1.4-1 .7l-7.1-5.9-7.5 5.3c-.9.6-1.3.3-1-.7l1.2-3.6 1.9-5.5-7.1-5.9c-.9-.7-.7-1.2.4-1.2l9 .3 3.1-8.8z"
      />
      <path
        fill="#FCC23A"
        d="M83.3.2h15.8c1.7 42.1-3.9 80-24.9 104.6 2.3 5.4 1.5 10.1-2.8 14.1l-.1 10.4c3.4 2.2 4.5 4.5 4.5 7.7 3.6.9 6 2.6 7 4.7v5.8h-2v-5.8c-1.9-2.8-6-4.2-7.7-4.4 0-1.7.8-4.7-3.7-8V119c.2-.4-2.2-.3-1.8-.4 4-1.2 5.7-9.7 1.6-13.2-3.5-2.9-3.7.7 1-3.4 2-1.8 4-7.4 5.2-11.6 7.8-26.7 11-58.3 7.9-90.2"
      />
      <path fill="#FFEE8F" d="M50.8.2c-.6 15.9-1 46.3 2.4 71.1C46 56.5 42 22.9 42.2.2h8.6" />
      <path
        fill="#FFF475"
        d="M64.6 104.6c-1.1 1.9-1.6 4.2-1.3 7.4-1.9-2.3-1.5-6.4 1.3-7.4M67.7 129.5c-1.3.8-2.5 2-3.5 4.1-.3-2.1 1.5-4.5 3.5-4.1M62.8 137.4c-1.7.8-3.5 2-5.7 4 1-1.9 4.2-4.1 5.7-4"
      />
      <path fill="#FCB23A" d="M41.7 174.9h55.4v-27.3H41.7z" />
      <path
        fill="#FEFEFE"
        opacity={0.591}
        d="M50.6 4.2c0 5.3-1 14-3 16-2.2 2.2-10.7 3.1-16 3.1 5.3 0 14.3 1 16 3 1.8 2.2 3.1 10.8 3.1 16 0-5.4.8-13.8 3-16 2.2-2.1 10.8-3.1 16-3.1-5.3 0-14.1-1-16-3-2-2.2-3-10.7-3.1-16"
      />
      <path
        fill="#FFD54B"
        d="M90.3 154c-1.3 0-2.4-1.1-2.4-2.4H50.8c0 1.3-1.1 2.4-2.4 2.4v14.4c1.3 0 2.4 1.1 2.4 2.4h37.1c0-1.3 1.1-2.4 2.4-2.4V154"
      />
      <path
        fill="#FCB23A"
        d="M88.7 153.3c.4.4 1 .7 1.6.7h.1v14.6h-.1c-.6 0-1.2.3-1.6.7-.4.4-.7 1-.7 1.6v.1H50.7v-.1c0-.6-.3-1.2-.7-1.6-.4-.4-1-.7-1.6-.7h-.1V154h.1c.6 0 1.2-.3 1.6-.7.4-.4.7-1 .7-1.6v-.1H88v.1c0 .6.3 1.1.7 1.6zm1.5.8c-.6 0-1.2-.3-1.7-.7-.4-.4-.7-1-.7-1.7H50.9c0 .6-.3 1.2-.7 1.7-.4.4-1 .7-1.7.7v14.2c.6 0 1.2.3 1.7.7.4.4.7 1 .7 1.7h36.9c0-.6.3-1.2.7-1.7.4-.4 1-.7 1.7-.7v-14.2z"
      />
      <path
        fill="#FCB23A"
        d="M86.4 155c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5M52.1 155c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5M86.4 166.8c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5M52.1 166.8c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5"
      />
    </svg>
  );
};

export default SvgComponent;
